export const DEMO_USER = {
  uid: "demo-user",
  full_name: "You",
  email: "you@example.com",
  phone_number: "16175550000",
  school: "Cornell University",
  industry: "Finance",
  role: "Junior, Finance Major",
  organization: "Cornell Finance Club",
  location: "Boston, MA",
  profile_photo_url: "",
  privacy_settings: {
    show_email: false,
    show_school: true,
    show_industry: true,
    show_role: true,
    show_organization: true,
  },
};

export const DEMO_CONNECTIONS = [
  {
    id: "demo-conn-1",
    initiator_uid: "demo-user",
    recipient_uid: "demo-nick",
    recipient_phone: "11235552222",
    status: "confirmed",
    relationship_type: "friend",
    connection_strength: "strong",
    where_met: "Met at freshman orientation",
    private_note: "Really solid guy, good contact for M&A roles",
    last_interacted_at: null,
    otherProfile: {
      id: "demo-nick",
      full_name: "Nick Jung",
      role: "Junior, Finance Major",
      school: "Cornell University",
      industry: "Finance",
      location: "Ridgewood, NJ",
      email: "nyj2@cornell.edu",
      phone_number: "11235552222",
      profile_photo_url: "",
      privacy_settings: { show_email: false, show_school: true, show_industry: true, show_role: true },
    },
  },
  {
    id: "demo-conn-2",
    initiator_uid: "demo-user",
    recipient_uid: "demo-matt",
    recipient_phone: "12015553434",
    status: "confirmed",
    relationship_type: "colleague",
    connection_strength: "moderate",
    where_met: "Accounting study group",
    private_note: "",
    last_interacted_at: null,
    otherProfile: {
      id: "demo-matt",
      full_name: "Matt Friscia",
      role: "Accounting Intern",
      school: "Cornell University",
      industry: "Accounting",
      location: "Franklin Lakes, NJ",
      email: "mjf366@cornell.edu",
      phone_number: "12015553434",
      profile_photo_url: "",
      privacy_settings: { show_email: false, show_school: true, show_industry: true, show_role: true },
    },
  },
  {
    id: "demo-conn-3",
    initiator_uid: "demo-user",
    recipient_uid: "demo-bill",
    recipient_phone: "19175559090",
    status: "confirmed",
    relationship_type: "acquaintance",
    connection_strength: "weak",
    where_met: "",
    private_note: "",
    last_interacted_at: null,
    otherProfile: {
      id: "demo-bill",
      full_name: "Bill Gates",
      role: "Retired CEO",
      school: "",
      industry: "Technology",
      location: "Seattle, WA",
      email: "",
      phone_number: "19175559090",
      profile_photo_url: "",
      privacy_settings: { show_email: false, show_school: true, show_industry: true, show_role: true },
    },
  },
  // Branched off Nick ("sub" mode) — a name-only contact who hangs off Nick,
  // not off you. Appears nested under Nick in the list and one hop past him in the graph.
  {
    id: "demo-conn-4",
    initiator_uid: "demo-user",
    recipient_uid: null,
    recipient_phone: "",
    recipient_name: "Danny Jung",
    status: "confirmed",
    relationship_type: "family",
    connection_strength: "moderate",
    where_met: "Nick's younger brother",
    private_note: "",
    last_interacted_at: null,
    branch_parent_uid: "demo-nick",
    branch_parent_name: "Nick Jung",
    branch_mode: "sub",
    otherProfile: null,
  },
  // Branched off Matt ("direct" mode) — still your direct contact, tagged "via Matt".
  // Appears top-level in the list with a via badge and as a degree-1 node with a
  // faint secondary link to Matt in the graph.
  {
    id: "demo-conn-5",
    initiator_uid: "demo-user",
    recipient_uid: "demo-sarah",
    recipient_phone: "14155557777",
    status: "confirmed",
    relationship_type: "colleague",
    connection_strength: "strong",
    where_met: "Introduced by Matt",
    private_note: "",
    last_interacted_at: null,
    branch_parent_uid: "demo-matt",
    branch_parent_name: "Matt Friscia",
    branch_mode: "direct",
    otherProfile: {
      id: "demo-sarah",
      full_name: "Sarah Chen",
      role: "Product Manager",
      school: "Cornell University",
      industry: "Technology",
      location: "San Francisco, CA",
      email: "",
      phone_number: "14155557777",
      profile_photo_url: "",
      privacy_settings: { show_email: false, show_school: true, show_industry: true, show_role: true },
    },
  },
  {
    id: "demo-conn-6",
    initiator_uid: "demo-user",
    recipient_uid: "demo-amara",
    recipient_phone: "12125558888",
    status: "confirmed",
    relationship_type: "alumni",
    connection_strength: "moderate",
    where_met: "Cornell alumni mixer in Manhattan",
    private_note: "",
    last_interacted_at: null,
    otherProfile: {
      id: "demo-amara",
      full_name: "Amara Okafor",
      role: "Senior Editor",
      school: "Columbia University",
      industry: "Media",
      location: "New York, NY",
      email: "",
      phone_number: "12125558888",
      profile_photo_url: "",
      privacy_settings: { show_email: false, show_school: true, show_industry: true, show_role: true },
    },
  },
  {
    id: "demo-conn-7",
    initiator_uid: "demo-user",
    recipient_uid: "demo-ravi",
    recipient_phone: "19175552121",
    status: "confirmed",
    relationship_type: "colleague",
    connection_strength: "strong",
    where_met: "Summer analyst program",
    private_note: "",
    last_interacted_at: null,
    otherProfile: {
      id: "demo-ravi",
      full_name: "Ravi Menon",
      role: "Summer Analyst",
      school: "NYU",
      industry: "Finance",
      location: "Brooklyn, NY",
      email: "",
      phone_number: "19175552121",
      profile_photo_url: "",
      privacy_settings: { show_email: false, show_school: true, show_industry: true, show_role: true },
    },
  },
  {
    id: "demo-conn-8",
    initiator_uid: "demo-user",
    recipient_uid: "demo-lena",
    recipient_phone: "16505553333",
    status: "confirmed",
    relationship_type: "colleague",
    connection_strength: "moderate",
    where_met: "Hackathon in Palo Alto",
    private_note: "",
    last_interacted_at: null,
    otherProfile: {
      id: "demo-lena",
      full_name: "Lena Ortiz",
      role: "Software Engineer",
      school: "Stanford University",
      industry: "Technology",
      location: "Palo Alto, CA",
      email: "",
      phone_number: "16505553333",
      profile_photo_url: "",
      privacy_settings: { show_email: false, show_school: true, show_industry: true, show_role: true },
    },
  },
  {
    id: "demo-conn-9",
    initiator_uid: "demo-user",
    recipient_uid: null,
    recipient_phone: "",
    recipient_name: "Tomas Reyes",
    status: "confirmed",
    relationship_type: "friend",
    connection_strength: "moderate",
    where_met: "Summer camp counsellor",
    private_note: "",
    last_interacted_at: null,
    otherProfile: null,
  },
];

// Self-contained gradient avatars: demo mode must work with no network, and a
// generated mark is honest about being a placeholder for a real photo.
function demoPhoto(from, to) {
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="160" height="160" viewBox="0 0 160 160"><defs><linearGradient id="g" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="${from}"/><stop offset="1" stop-color="${to}"/></linearGradient></defs><rect width="160" height="160" fill="url(#g)"/><circle cx="80" cy="62" r="26" fill="rgba(255,255,255,0.32)"/><path d="M24 160c0-31 25-52 56-52s56 21 56 52z" fill="rgba(255,255,255,0.32)"/></svg>`;
  return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
}

// Rich detail for the full-page connection profile.
const DEMO_DETAILS = {
  "demo-conn-1": {
    photo_url: demoPhoto("#1C3F5E", "#4B7DA3"),
    birthday: "2004-03-18",
    socials: { linkedin: "https://linkedin.com/in/nickjung" },
    moments: [
      { id: "m-1", title: "Cornell finance club case competition", date: "2026-04", note: "We placed second." },
      { id: "m-2", title: "Freshman orientation week", date: "2023-08" },
    ],
    career: [
      { id: "c-1", title: "Investment Banking Summer Analyst", org: "Evercore", start: "2026-06", current: true },
      { id: "c-2", title: "Finance Intern", org: "Ridgewood Capital", start: "2025-06", end: "2025-08" },
    ],
    education: [{ id: "e-1", school: "Cornell University", degree: "BS, Applied Economics", year: "2027" }],
    locations: [
      { id: "l-1", label: "Ithaca, NY", current: true },
      { id: "l-2", label: "Ridgewood, NJ" },
    ],
  },
  "demo-conn-5": {
    locations: [{ id: "l-5", label: "San Francisco, CA", current: true }],
  },
  "demo-conn-2": {
    photo_url: demoPhoto("#2D6A4F", "#6FA88C"),
    birthday: "2004-11-02",
    socials: { linkedin: "https://linkedin.com/in/mattfriscia", instagram: "https://instagram.com/mattfriscia" },
    moments: [
      { id: "m-3", title: "Accounting study group all-nighter", date: "2025-12" },
      { id: "m-4", title: "Spring break in Charleston", date: "2026-03" },
    ],
    career: [{ id: "c-3", title: "Accounting Intern", org: "Deloitte", start: "2026-06", current: true }],
    education: [{ id: "e-2", school: "Cornell University", degree: "BS, Accounting", year: "2027" }],
    locations: [{ id: "l-3", label: "Ithaca, NY", current: true }],
  },
  "demo-conn-6": {
    photo_url: demoPhoto("#92400E", "#C88A4A"),
    locations: [{ id: "l-6", label: "New York, NY", current: true }],
    career: [{ id: "c-6", title: "Senior Editor", org: "Conde Nast", current: true }],
  },
  "demo-conn-7": {
    photo_url: demoPhoto("#1C3F5E", "#5E8FB5"),
    locations: [{ id: "l-7", label: "Brooklyn, NY", current: true }],
  },
  "demo-conn-8": {
    photo_url: demoPhoto("#4B5563", "#8A94A3"),
    locations: [{ id: "l-8", label: "Palo Alto, CA", current: true }],
  },
  "demo-conn-9": {
    locations: [{ id: "l-9", label: "Ithaca, NY", current: true }],
  },
  "demo-conn-4": {
    photo_url: demoPhoto("#6D28D9", "#A57BE8"),
    locations: [{ id: "l-4", label: "Ithaca, NY", current: true }],
    moments: [{ id: "m-5", title: "Phi Gamma Delta rush weekend", date: "2025-09" }],
  },
};

function facetFromLegacy(connection, discoveryEnabled = true) {
  const origin = connection.branch_parent_uid
    ? {
        kind: "user",
        user_uid: connection.branch_parent_uid,
        name: connection.branch_parent_name || "",
        mode: connection.branch_mode || "direct",
      }
    : null;
  return {
    relationship_type: connection.relationship_type || "friend",
    connection_strength: connection.connection_strength || "moderate",
    closeness: connection.closeness || (connection.connection_strength === "strong" ? 5 : 3),
    where_met: connection.where_met || "",
    private_note: connection.private_note || "",
    last_interacted_at: connection.last_interacted_at || null,
    discovery_enabled: discoveryEnabled,
    ...(origin ? { origin } : {}),
  };
}

// Context-aware demo data mirrors the v2 private rolodex schema. It deliberately
// includes a dual-context person and a professional connection introduced by a
// personal-only bridge so every new state is visible without Firebase.
export const DEMO_ROLODEX = DEMO_CONNECTIONS.map((connection) => {
  const base = {
    id: connection.id,
    owner_uid: DEMO_USER.uid,
    recipient_uid: connection.recipient_uid || null,
    recipient_name: connection.recipient_name || connection.otherProfile?.full_name || "",
    recipient_phone: connection.recipient_phone || "",
    otherProfile: connection.otherProfile || null,
    ...(DEMO_DETAILS[connection.id] || {}),
    facets: {},
  };

  if (connection.id === "demo-conn-4") {
    base.private_profile = {
      role: "Student",
      organization: "Phi Gamma Delta",
      school: "Cornell University",
      industry: "Education",
      location: "Ithaca, NY",
      email: "danny@example.com",
    };
  }

  if (connection.id === "demo-conn-1") {
    base.facets.professional = facetFromLegacy({
      ...connection,
      relationship_type: "alumni",
      where_met: "Cornell finance club",
    });
    base.facets.personal = facetFromLegacy(connection, false);
  } else if (connection.id === "demo-conn-2") {
    base.facets.personal = facetFromLegacy(
      { ...connection, relationship_type: "friend", where_met: "Accounting study group" },
      true
    );
  } else if (connection.id === "demo-conn-4") {
    base.facets.personal = facetFromLegacy(connection, false);
  } else {
    base.facets.professional = facetFromLegacy(connection, true);
  }
  return base;
});

export const DEMO_PROFILES = {
  ...Object.fromEntries(
    DEMO_CONNECTIONS.filter((connection) => connection.recipient_uid).map((connection) => [
      connection.recipient_uid,
      connection.otherProfile,
    ])
  ),
  "demo-jordan": {
    id: "demo-jordan",
    full_name: "Jordan Lee",
    role: "Investment Banking Analyst",
    school: "Cornell University",
    industry: "Finance",
    organization: "Alpha Phi Alpha",
    privacy_settings: { show_school: true, show_industry: true, show_role: true, show_organization: true },
  },
  "demo-priya": {
    id: "demo-priya",
    full_name: "Priya Shah",
    role: "Product Designer",
    school: "RISD",
    industry: "Technology",
    privacy_settings: { show_school: true, show_industry: true, show_role: true },
  },
};

export const DEMO_DISCOVERY_EDGES = [
  { source_uid: "demo-user", target_uid: "demo-nick" },
  // Matt is personal-only, but explicitly opted into introduction paths.
  { source_uid: "demo-user", target_uid: "demo-matt" },
  { source_uid: "demo-user", target_uid: "demo-bill" },
  { source_uid: "demo-user", target_uid: "demo-sarah" },
  { source_uid: "demo-nick", target_uid: "demo-jordan" },
  { source_uid: "demo-matt", target_uid: "demo-priya" },
  { source_uid: "demo-user", target_uid: "demo-amara" },
  { source_uid: "demo-user", target_uid: "demo-ravi" },
  { source_uid: "demo-user", target_uid: "demo-lena" },
];

/**
 * Demo stand-in for the phone_index lookup. Without this, demo mode can never
 * exercise the "this person already has an Aline account" path, which is where
 * the registered-recipient rules and the personal/professional choice differ.
 */
export function findDemoProfileByPhone(normalizedPhone) {
  if (!normalizedPhone) return null;
  const match = DEMO_CONNECTIONS.find(
    (connection) =>
      connection.recipient_uid &&
      String(connection.recipient_phone || "").replace(/\D/g, "") ===
        String(normalizedPhone).replace(/\D/g, "")
  );
  return match?.otherProfile || null;
}
